import React, { Component, Fragment } from "react";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import NumberFormat from "react-number-format";
import KurdishSoraniNumbersToWords from "kurdish-numbers-to-words/Sorani.js";
import n2wordsEN from "n2words/lib/i18n/AR.mjs";
export class PrintViewParadan extends Component {
 render() {
  const {
   change_Lang,
   view_paradan_obj,
   primary_logo_bill,
   footer_logo_bill,
   lang,
  } = this.props;
  let numberWordsSorani =
   view_paradan_obj.Amount !== ""
    ? KurdishSoraniNumbersToWords.convert(view_paradan_obj.Amount)
    : 0;
  let numWords1 =
   view_paradan_obj.Amount !== undefined && view_paradan_obj.Amount !== null
    ? n2wordsEN(
       parseFloat(view_paradan_obj.Amount.toString().replace(/,/g, ""))
      )
    : 0;
  return (
   <Fragment>
    <div class="card product-page-main card-body">
     <div class="card-body p-0" id="yy">
      <div className="fk">
       <div class="row">
        <div class="col-12  ">
         <img
          src={primary_logo_bill}
          alt="logo"
          className="img-fluid img-responsive"
          style={{
           position: "relative",
           top: -10,
           width: "100%",
          }}
         />
        </div>
       </div>
       <div class="row mt-3">
        <div class="col-3">
         <p
          style={{
           fontSize: "22px",
           color: "#2e425d",
           textAlign: "right",
           fontWeight: "bold",
          }}
          class=" text-uppercase"
         >
          &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
          <Time
           value={view_paradan_obj.createdAt}
           format="YYYY-MM-DD"
           style={{
            fontSize: "22px",
            color: "#2e425d",
            fontWeight: "bold",
           }}
          />
         </p>
        </div>
        <div class="col-6 d-flex justify-content-center">
         <p
          style={{
           fontSize: "24px",
           color: "#2e425d",
           fontWeight: "bolder",
          }}
          class={`d-flex justify-content-center text-uppercase ${
           lang !== "en" ? "fk" : "fkp"
          } `}
         >
          {change_Lang("Payment bills")} ({change_Lang(view_paradan_obj.type)})
         </p>
        </div>
        <div class="col-3 text-right">
         <p
          style={{
           fontSize: "22px",
           color: "#2e425d",
           fontWeight: "bold",
          }}
          class=" text-uppercase"
         >
          {change_Lang("in_invoice")}#&nbsp;
          {view_paradan_obj.invoice_No}&nbsp;
         </p>
        </div>
       </div>
       {/* first row */}
       <div
        class="row mt-3"
        style={{ width: "100%", backgroundColor: "#f4f4f6" }}
       >
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          وەرگر/المستلم :
         </label>
        </div>
        <div class="col-6 d-flex justify-content-center">
         {" "}
         <label
          className="fk col-form-label d-flex justify-content-start"
          style={{
           fontSize: "18px",
           color: "black",
          }}
         >
          {view_paradan_obj.payer}
         </label>
        </div>
        <div class="col-3 d-flex justify-content-end">
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fkb"
         >
          : Receipt from
         </label>
        </div>
       </div>
       {/* second row */}
       <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          بڕی پارە / مبلغ و قدره :
         </label>
        </div>
        <div class="col-6 d-flex justify-content-center">
         {" "}
         <span className="fk" style={{ fontWeight: "bold", marginTop: "12px" }}>
          {change_Lang("Only")}
         </span>
         &nbsp; &nbsp;
         <NumberFormat
          displayType="text"
          thousandSeparator={true}
          value={view_paradan_obj.Amount}
          style={{
           fontSize: "20px",
           color: "black",
          }}
          className="col-form-label"
          prefix={`${view_paradan_obj.currency === "dolar" ? "$" : "ID"}`}
         />
         &nbsp;&nbsp;
         <span className="fk" style={{ fontWeight: "bold", marginTop: "12px" }}>
          {" "}
          {lang === "krd" ? numberWordsSorani : numWords1}&nbsp;
          {`${
           view_paradan_obj.currency === "dolar" ? "دۆلاری ئەمریکی" : "دینار"
          }`}
         </span>
        </div>
        <div class="col-3 d-flex justify-content-end">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fkb"
         >
          : Amount
         </label>
        </div>
       </div>
       {/* third row */}
       <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          لە بڕی / وذلك عن :
         </label>
        </div>
        <div class="col-8 d-flex justify-content-center">
         {view_paradan_obj.type !== "investor" &&
         view_paradan_obj.instead_of === "" ? (
          <>
           <span
            className="fk d-flex justify-content-center  mt-2"
            style={{
             fontSize: "16px",
             color: "black",
             textAlign: "justify",
            }}
           >
            {view_paradan_obj.type !== "Monthly rent invoice" ? (
             <>
              {change_Lang(view_paradan_obj.type)} (
              {change_Lang(view_paradan_obj.property)})&nbsp;
              {change_Lang("from")}
              &nbsp;({view_paradan_obj.place}) &nbsp;
              {change_Lang("Number")}&nbsp;({view_paradan_obj.num})
             </>
            ) : (
             <>
              {change_Lang(view_paradan_obj.type)} (
              {change_Lang(view_paradan_obj.property)})&nbsp;
              {change_Lang("from")}
              &nbsp;({view_paradan_obj.place}) &nbsp;
              {change_Lang("Number")}&nbsp;({view_paradan_obj.num}
              )&nbsp;
              {change_Lang("from")}&nbsp;
              {view_paradan_obj.from}
              &nbsp;
              {change_Lang("to")}&nbsp;
              {view_paradan_obj.to}
             </>
            )}
           </span>
          </>
         ) : (
          <span
           className="fk d-flex justify-content-center mt-2"
           style={{
            fontSize: "16px",
            color: "black",
            textAlign: "justify",
           }}
          >
           {view_paradan_obj && view_paradan_obj.instead_of}
          </span>
         )}
        </div>
        <div class="col-1 d-flex justify-content-end">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fkb"
         >
          : For
         </label>
        </div>
       </div>
       {/* five row */}
       <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          پارەدەر / الدافع :
         </label>
        </div>
        <div class="col-6 d-flex justify-content-center">
         {" "}
         <label
          className="fk col-form-label"
          style={{
           fontSize: "18px",
           color: "black",
          }}
         >
          {view_paradan_obj.reciver}
         </label>
        </div>
        <div class="col-3 d-flex justify-content-end">
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label"
         >
          : Receptor
         </label>
        </div>
       </div>
       {/* note */}
       <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          تێبینی / الملاحظات :
         </label>
        </div>
        <div class="col-6 d-flex justify-content-center">
         {" "}
         <label
          className="fk col-form-label"
          style={{
           fontSize: "18px",
           color: "black",
          }}
         >
          {view_paradan_obj.note}
         </label>
        </div>
        <div class="col-3 d-flex justify-content-end">
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label"
         >
          : Note
         </label>
        </div>
       </div>
       {/* six row */}
       <br /> <br />
       <div class="row">
        <div class="col-6 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
           fontWeight: "bold",
          }}
          class=" col-form-label fk"
         >
          (پارەدەر)&nbsp;واژوو / توقيع
         </label>
        </div>
        <div class="col-6 d-flex justify-content-end">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
           fontWeight: "bold",
          }}
          class=" col-form-label fk"
         >
          (پارەوەرگر)&nbsp;واژوو / توقيع
         </label>
        </div>
        <div class="col-6 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          {view_paradan_obj.reciver}
         </label>
        </div>
        <div class="col-6 d-flex justify-content-end">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          {view_paradan_obj.payer}
         </label>
        </div>
       </div>
       {/* footer */}
       <br /> <br />
       <div
        className="row"
        style={{
         width: "100%",
         marginLeft: "20px",
        }}
       >
        <div className="col-12">
         <img src={footer_logo_bill} alt="logo" width="100%" />
        </div>
       </div>
      </div>
      {/* Second Invoice */}
      <br />
      <hr style={{ border: "1px dashed black" }} />
      <div className="fk">
       <div class="row">
        <div class="col-12  ">
         <img
          src={primary_logo_bill}
          alt="logo"
          className="img-fluid img-responsive"
          style={{
           position: "relative",
           top: 0,
           width: "100%",
          }}
         />
        </div>
       </div>
       <div class="row mt-3">
        <div class="col-3">
         <p
          style={{
           fontSize: "22px",
           color: "#2e425d",
           textAlign: "right",
           fontWeight: "bold",
          }}
          class=" text-uppercase"
         >
          &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
          <Time
           value={view_paradan_obj.createdAt}
           format="YYYY-MM-DD"
           style={{
            fontSize: "22px",
            color: "#2e425d",
            fontWeight: "bold",
           }}
          />
         </p>
        </div>
        <div class="col-6 d-flex justify-content-center">
         <p
          style={{
           fontSize: "24px",
           color: "#2e425d",
           fontWeight: "bolder",
          }}
          class={`d-flex justify-content-center text-uppercase ${
           lang !== "en" ? "fk" : "fkp"
          } `}
         >
          {change_Lang("Payment bills")} ({change_Lang(view_paradan_obj.type)})
         </p>
        </div>
        <div class="col-3 text-right">
         <p
          style={{
           fontSize: "22px",
           color: "#2e425d",
           fontWeight: "bold",
          }}
          class=" text-uppercase"
         >
          {change_Lang("in_invoice")}#&nbsp;
          {view_paradan_obj.invoice_No}&nbsp;
         </p>
        </div>
       </div>
       {/* first row */}
       <div
        class="row mt-3"
        style={{ width: "100%", backgroundColor: "#f4f4f6" }}
       >
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          وەرگر/المستلم :
         </label>
        </div>
        <div class="col-6 d-flex justify-content-center">
         {" "}
         <label
          className="fk col-form-label d-flex justify-content-start"
          style={{
           fontSize: "18px",
           color: "black",
          }}
         >
          {view_paradan_obj.payer}
         </label>
        </div>
        <div class="col-3 d-flex justify-content-end">
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fkb"
         >
          : Receipt from
         </label>
        </div>
       </div>
       {/* second row */}
       <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          بڕی پارە / مبلغ و قدره :
         </label>
        </div>
        <div class="col-6 d-flex justify-content-center">
         <span className="fk" style={{ fontWeight: "bold", marginTop: "12px" }}>
          {change_Lang("Only")}
         </span>
         &nbsp; &nbsp;
         <NumberFormat
          displayType="text"
          thousandSeparator={true}
          value={view_paradan_obj.Amount}
          style={{
           fontSize: "20px",
           color: "black",
          }}
          className="col-form-label"
          prefix={`${view_paradan_obj.currency === "dolar" ? "$" : "ID"}`}
         />
         &nbsp;&nbsp;
         <span className="fk" style={{ fontWeight: "bold", marginTop: "12px" }}>
          {" "}
          {lang === "krd" ? numberWordsSorani : numWords1}&nbsp;
          {`${
           view_paradan_obj.currency === "dolar" ? "دۆلاری ئەمریکی" : "دینار"
          }`}
         </span>
        </div>
        <div class="col-3 d-flex justify-content-end">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fkb"
         >
          : Amount
         </label>
        </div>
       </div>
       {/* third row */}
       <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          لە بڕی / وذلك عن :
         </label>
        </div>
        <div class="col-8 d-flex justify-content-center">
         {view_paradan_obj.type !== "investor" &&
         view_paradan_obj.instead_of === "" ? (
          <>
           <span
            className="fk d-flex justify-content-center  mt-2"
            style={{
             fontSize: "16px",
             color: "black",
             textAlign: "justify",
            }}
           >
            {view_paradan_obj.type !== "Monthly rent invoice" ? (
             <>
              {change_Lang(view_paradan_obj.type)} (
              {change_Lang(view_paradan_obj.property)})&nbsp;
              {change_Lang("from")}
              &nbsp;({view_paradan_obj.place}) &nbsp;
              {change_Lang("Number")}&nbsp;({view_paradan_obj.num})
             </>
            ) : (
             <>
              {change_Lang(view_paradan_obj.type)} (
              {change_Lang(view_paradan_obj.property)})&nbsp;
              {change_Lang("from")}
              &nbsp;({view_paradan_obj.place}) &nbsp;
              {change_Lang("Number")}&nbsp;({view_paradan_obj.num}
              )&nbsp;
              {change_Lang("from")}&nbsp;
              {view_paradan_obj.from}
              &nbsp;
              {change_Lang("to")}&nbsp;
              {view_paradan_obj.to}
             </>
            )}
           </span>
          </>
         ) : (
          <span
           className="fk d-flex justify-content-center mt-2"
           style={{
            fontSize: "16px",
            color: "black",
            textAlign: "justify",
           }}
          >
           {view_paradan_obj && view_paradan_obj.instead_of}
          </span>
         )}
        </div>
        <div class="col-1 d-flex justify-content-end">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fkb"
         >
          : For
         </label>
        </div>
       </div>
       {/* five row */}
       <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          پارەدەر / الدافع :
         </label>
        </div>
        <div class="col-6 d-flex justify-content-center">
         {" "}
         <label
          className="fk col-form-label"
          style={{
           fontSize: "18px",
           color: "black",
          }}
         >
          {view_paradan_obj.reciver}
         </label>
        </div>
        <div class="col-3 d-flex justify-content-end">
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label"
         >
          : Receptor
         </label>
        </div>
       </div>
       {/* note */}
       <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          تێبینی / الملاحظات :
         </label>
        </div>
        <div class="col-6 d-flex justify-content-center">
         {" "}
         <label
          className="fk col-form-label"
          style={{
           fontSize: "18px",
           color: "black",
          }}
         >
          {view_paradan_obj.note}
         </label>
        </div>
        <div class="col-3 d-flex justify-content-end">
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label"
         >
          : Note
         </label>
        </div>
       </div>
       {/* six row */}
       <br /> <br />
       <div class="row">
        <div class="col-6 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
           fontWeight: "bold",
          }}
          class=" col-form-label fk"
         >
          (پارەدەر)&nbsp;واژوو / توقيع
         </label>
        </div>
        <div class="col-6 d-flex justify-content-end">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
           fontWeight: "bold",
          }}
          class=" col-form-label fk"
         >
          (پارەوەرگر)&nbsp;واژوو / توقيع
         </label>
        </div>
        <div class="col-6 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          {view_paradan_obj.reciver}
         </label>
        </div>
        <div class="col-6 d-flex justify-content-end">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          {view_paradan_obj.payer}
         </label>
        </div>
       </div>
       {/* footer */}
       <div
        className="row"
        style={{
         width: "100%",
         // marginLeft: "20px",
         position: "fixed",
         bottom: -5,
        }}
       >
        <div className="col-12">
         <img src={footer_logo_bill} alt="logo" width="100%" />
        </div>
       </div>
      </div>
     </div>
    </div>
   </Fragment>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  view_paradan_obj: state.Invoice_Reducer.view_paradan_obj,
  index_Paradan: state.Invoice_Reducer.index_Paradan,
  user: state.AuthReducer.user,
  primary_logo_bill: state.HelperReducer.primary_logo_bill,
  footer_logo_bill: state.HelperReducer.footer_logo_bill,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintViewParadan);
